import React from 'react';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { LinearProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { Dialog } from '@paragon/popup-state';

export function LoadingSettingsDialog() {
  return (
    <Dialog insistent variant="design">
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <SettingsApplicationsIcon sx={{ fontSize: '96px' }} />
      </Box>

      <Typography sx={{ marginY: 2 }}>Loading Settings...</Typography>

      <LinearProgress />
    </Dialog>
  );
}
